<h1 mat-dialog-title>Release the financing hold?</h1>

<form [formGroup]="form" (ngSubmit)="submit()" novalidate>
  <div mat-dialog-content class="release-financing-hold-dialog">
    <p class="hold-description">{{ description }}</p>
    <p class="hold-placed">
      Placed by {{ data.hold.placed_by?.name }} on {{ data.hold.placed_at | date: 'd.M.yyyy' }}.
    </p>
    <p class="release-message">
      Releasing lets financing resume for the invoices this hold applies to, unless another hold still applies.
    </p>

    <mat-form-field class="full-width">
      <mat-label>Note</mat-label>
      <textarea
        matInput
        rows="3"
        class="note-input"
        placeholder="Why can financing resume?"
        formControlName="note"
      ></textarea>
      <mat-hint>Kept with the hold's history.</mat-hint>
    </mat-form-field>

    <p class="error-message" role="alert" *ngIf="errorMessage">{{ errorMessage }}</p>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
    <button mat-button type="submit" color="primary" class="confirm-button" [disabled]="!canSubmit">Release hold</button>
  </div>
</form>
